function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import crypto from 'crypto-js';
import sha256 from 'crypto-js/sha256';
import HmacSHA256 from 'crypto-js/hmac-sha256';

function getDate(timestamp) {
  var date = new Date(timestamp * 1000);
  var year = date.getUTCFullYear();
  var month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
  var day = ('0' + date.getUTCDate()).slice(-2);
  return "".concat(year, "-").concat(month, "-").concat(day);
} // 判断是否是json类型


function isJSON(obj) {
  if (_typeof(obj) == "object" && Object.prototype.toString.call(obj).toLowerCase() == "[object object]" && !obj.length) {
    return true;
  } else {
    return false;
  }
} // 模拟浏览器转码


function urlencode(str) {
  str = (str + '').toString();
  return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+').replace(/%3A/g, ':');
}

function main(httpRequestMethod, canonicalUri, canonicalQuery, header) {
  // 处理参数为字符串
  var canonicalQueryString = ''; // get请求

  if (httpRequestMethod.toUpperCase() == 'GET') {
    for (var i in canonicalQuery) {
      if (typeof canonicalQuery[i] !== 'undefined') {
        // 参数里面有等号，转成%3D,算加密
        // 是字符串在正则替换，不是原样输出
        var curr = Object.prototype.toString.call(canonicalQuery[i]) == "[object String]" ? urlencode(canonicalQuery[i]) : canonicalQuery[i];
        canonicalQueryString += i + '=' + curr + '&';
      }
    } // 此处%会被encodeURI转成%25


    canonicalQueryString = encodeURI(canonicalQueryString.substring(0, canonicalQueryString.length - 1)); // 强制转回处理

    canonicalQueryString = canonicalQueryString.replace(/%25/g, '%');
    console.log('canonicalQueryString', canonicalQueryString);
  } // 密钥参数


  var SECRET_ID = '14f108e92470bdb6a9491fe038b68632036d20f13dbf23d9a935452de698e025'; // 需要改

  var SECRET_KEY = '60cdbe02dfcceadf4460629a5081a2c91236a578c3f165d422db7b39f67598b1'; // 需要改
  // const endpoint = window.location.host // 需要改

  var service = 'webh5'; // const region = "ap-guangzhou"
  // const action = "DescribeInstances"

  var version = '1.0.0'; // const timestamp = getTime()

  var timestamp = parseInt(new Date().getTime() / 1000); // 时间处理, 获取世界时间日期

  var date = getDate(timestamp); // ************* 步骤 1：拼接规范请求串 *************

  var signedHeaders = 'x-tc-version'; // 需要改 和 canonicalHeaders 一样。取canonicalHeaders key值。升序、小写。
  // post 请求数据有2种
  // header[httpRequestMethod.toLowerCase()]['Content-Type'] 区分不出来，所以用是否为json区分
  // Content-Type: application/json;charset=UTF-8 =>json类型，需要转字符串
  // Content-Type: application/x-www-form-urlencoded 原样输出

  var payload = httpRequestMethod.toUpperCase() == 'GET' ? '' : isJSON(canonicalQuery) ? JSON.stringify(canonicalQuery) : canonicalQuery; // header[httpRequestMethod.toLowerCase()]['Content-Type'] === 'application/x-www-form-urlencoded' ?  : JSON.stringify(canonicalQuery)  // 需要改  body里所有内容转成字符串。get请求的话是空字符串，post请求body内容。

  var hashedRequestPayload = sha256(payload); // sjcl.codec.hex.fromBits(sjcl.hash.sha256.hash(payload));
  // const httpRequestMethod = "GET" //需要改  请求方式（GET/POST 大写）
  // const canonicalUri = "/active/freeInsurance/list"         //需要改  url 不带参数  /web/auth 到 ？前面的接口
  // const canonicalQueryString = "user_cid=26251017-579b-4d23-bb47-126c98594212&status=0&page=1&size=20"  //需要改   post 传空。get请求传递？后面的参数。

  var canonicalHeaders = '' + 'x-tc-version:' + version + '\n'; // 需要改  请求头里面的 content-type \n host。 \n必填。要求：小写、去掉首尾空格、按照key升序。 形式：key:value。

  var canonicalRequest = httpRequestMethod.toString().toUpperCase() + '\n' + canonicalUri + '\n' + canonicalQueryString + '\n' + canonicalHeaders + '\n' + signedHeaders + '\n' + hashedRequestPayload; // console.log(1111111111,canonicalRequest)
  // ************* 步骤 2：拼接待签名字符串 *************

  var algorithm = 'TC3-HMAC-SHA256';
  var hashedCanonicalRequest = sha256(canonicalRequest); // sjcl.codec.hex.fromBits(sjcl.hash.sha256.hash(canonicalRequest));

  var credentialScope = date + '/' + service + '/' + 'tc3_request';
  var stringToSign = algorithm + '\n' + timestamp + '\n' + credentialScope + '\n' + hashedCanonicalRequest; // console.log(2222222222222,stringToSign)
  // ************* 步骤 3：计算签名 *************
  // const kDate = HmacSHA256(date, 'TC3' + SECRET_KEY)
  // const kService = HmacSHA256(service, kDate)
  // const kSigning = HmacSHA256('tc3_request', kService)
  // const signature = crypto.enc.Hex.stringify(HmacSHA256(stringToSign.toString(), kSigning))

  var kService = HmacSHA256(service, 'TC3' + SECRET_KEY);
  var kVersion = HmacSHA256(version, kService);
  var kData = HmacSHA256(date, kVersion);
  var kSigning = HmacSHA256('tc3_request', kData);
  var signature = crypto.enc.Hex.stringify(HmacSHA256(stringToSign.toString(), kSigning)); // console.log(333333333,signature)
  // ************* 步骤 4：拼接 Authorization *************

  var authorization = algorithm + ' ' + 'Credential=' + SECRET_ID + '/' + credentialScope + ', ' + 'SignedHeaders=' + signedHeaders + ', ' + 'Signature=' + signature; // console.log(444444444,authorization)
  // const Call_Information = 'curl -X POST ' + "https://" + endpoint
  //                        + ' -H "X-TC-Authorization: ' + authorization + '"' // 最终结果
  //                        + ' -H "Content-Type: application/json; charset=utf-8"'
  //                        + ' -H "Host: ' + endpoint + '"'
  //                     //    + ' -H "X-TC-Action: ' + action + '"'
  //                        + ' -H "X-TC-Timestamp: ' + timestamp.toString() + '"' // 最终结果
  //                        + ' -H "X-TC-Version: ' + version + '"' // 最终结果
  //                     //    + ' -H "X-TC-Region: ' + region + '"'
  //                        + " -d '" + payload + "'"

  return {
    // "Content-Type": "application/json; charset=utf-8",
    'X-TC-Authorization': authorization,
    'X-TC-Timestamp': timestamp.toString(),
    'X-TC-Version': version
  };
}

export default main;